import { Box, Drawer, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  setbillerMenuseletected,
  setBillNo,
  setMobileTableDrawer,
  setTableName,
} from "../../app/store/reducer";
import fireDb from "../../utils/firebase";
import TableWithBox from "../../common/table";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Swal from "sweetalert2";
import {
  TableSectionListApi,
  getBillCounterSell,
  tableListApi,
} from "./counterSellApi";
import { payloadDateFormat } from "../../utils/commonUtils";
import { getBill, getData } from "./counterSellApiHandlers";
import { callbackHandlerCounterSell_ } from "./countersellSetParameter";
import { getAllEmployeeList } from "../employeeInfo/appoinmentDashboardApi";
import { PopEmployee } from "./popEmploye";
import calendar from "../../assets/icon/calendarblack.png";

export default function CounterSell() {
  const navigate = useNavigate();
  const [section, setSections] = useState([]);
  const [tables, setTables] = useState([]);
  const [sectionPresent, setSectionPresent] = useState(false);
  const dispatch = useDispatch();
  const [billCount, setBillCount] = useState({});
  const [bookedTables, setBookedTaBles] = useState();
  const billNumber = useSelector((state) => state.reducer.billNumber);
  const [pagination, setPagination] = useState({
    page: 1,
    total: 1,
    records: 0,
    pageSize: 4,
  });
  const [search, setSearch] = useState("");
  const [searchOutStandingsModal, setSearchOutStandingsModal] = useState(false);
  const [bills, setBills] = useState([]);
  const [numberOfRecords, setNumberOfRecords] = useState(1);
  const callbackHandlerCounterSell = callbackHandlerCounterSell_(
    getBill,
    {
      date: payloadDateFormat(),
      status: "null",
      filter: "null",
      search: "null",
      page: 1,
      pageSize: 10,
    },
    getBillCounterSell,
    Swal,
    billNumber,
    dispatch,
    setBillNo,
    setBills,
    setBillCount,
    billCount,
    getData,
    TableSectionListApi,
    setSections,
    tableListApi,
    setSectionPresent,
    setTables
  );
  const [appoinmentId, setAppoinmentId] = useState("");

  useEffect(() => {
    getAllEmployeeList((res) => {
      console.log("getAllEmployeeList", res);
      setTables(res?.list);
    });
  }, []);

  const userDetail = useSelector((state) => state.reducer.userDetail);
  useEffect(() => {
    console.log("tables ", tables);
  }, [tables]);

  useEffect(() => {
    console.log("bookedTables ", bookedTables);
  }, [bookedTables]);
  const handleDataChange = (snapshot, eventMode) => {
    const tableOrderData = [];
    if (eventMode === "on") {
      snapshot.forEach((childSnapshot) => {
        const tableData = childSnapshot.val();
        tableOrderData.push(tableData.name);
      });
      console.log("bookedTables firebase ", tableOrderData);
      setBookedTaBles(tableOrderData);
    }
  };

  const [filter, setFilter] = useState("employeemasterid");

  useEffect(() => {
    let parentNodeRef = null;
    if (userDetail?.mobileNumber) {
      parentNodeRef = fireDb.child(`${userDetail?.mobileNumber}/bookedTables`);
      parentNodeRef?.on("value", (e) => {
        console.log("bookedTables on ");
        handleDataChange(e, "on");
      });
    }
    return () => {
      parentNodeRef?.off("value", (e) => {
        console.log("bookedTables off ");
        handleDataChange(e, "off");
      });
    };
  }, [userDetail]);
  const billerMenuseletec = useSelector(
    (state) => state.reducer.billerMenuseletec
  );
  const drawerShow = useSelector((state) => state.reducer.drawerShow);
  const mobileTableDrawer = useSelector(
    (state) => state.reducer.mobileTableDrawer
  );

  const changeState = (newState) => {
    setSearchOutStandingsModal(newState);
  };

  return (
    <>
      <Box
        px={{ xs: 2, sm: 4 }}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Grid container alignItems="center" spacing={2}>
          <Grid item>
            <ArrowBackIcon
              onClick={() => dispatch(setbillerMenuseletected(0))}
              sx={{ cursor: "pointer" }}
            />
          </Grid>
          <Grid
            item
            xs
            // xs={12}
            // gap={2}
            // sx={{
            //   background:
            //     "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
            //   padding: "10px",
            //   mt: "10px",
            //   borderRadius: "5px",
            //   color: "#01008B",
            //   textAlign: "left",
            //   marginBottom: "20px",
            //   fontFamily: "'Montserrat', sans-serif",
            //   fontSize: "20px",
            //   fontWeight: 500,
            //   display: "flex",
            //   alignItems: "center",
            // }}
          >
            <Box
              sx={{
                background:
                  "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
                padding: "10px",
                mt: "10px",
                borderRadius: "5px",
                color: "#01008B",
                textAlign: "left",
                marginBottom: "20px",
                fontFamily: "'Montserrat', sans-serif",
                fontSize: "20px",
                fontWeight: 500,
              }}
            >
              <Typography
                sx={{
                  typography: { xs: "h6", sm: "h6" },
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Previous Bills
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid container>
          {!searchOutStandingsModal && (
            <>
              <Grid item xs={12} sm={12}>
                {billerMenuseletec == 0 && (
                  <>
                    <Grid item sx={{}}>
                      <PopEmployee
                        sectionPresent={sectionPresent}
                        tables={tables}
                        dispatch={dispatch}
                        navigate={navigate}
                        bookedTables={bookedTables}
                        section={section}
                        setTableName={setTableName}
                      />
                    </Grid>
                  </>
                )}
                {billerMenuseletec !== 0 && (
                  <TableWithBox
                    filter={filter}
                    setFilter={setFilter}
                    appoinmentId={appoinmentId}
                    setAppoinmentId={setAppoinmentId}
                    callgetAllEmp={(data) => {
                      callbackHandlerCounterSell.getBill.callback({
                        ...callbackHandlerCounterSell.getBill.parameter,
                        payload: {
                          ...callbackHandlerCounterSell.getBill.parameter
                            .payload,
                          ...data,
                        },
                      });
                    }}
                    changeState={changeState}
                    data={bills}
                    setBills={setBills}
                    pagesCount={billCount?.totalBills}
                    billApiCall={(da, search) => {
                      callbackHandlerCounterSell.getBill.callback({
                        ...callbackHandlerCounterSell.getBill.parameter,
                        payload: {
                          ...callbackHandlerCounterSell.getBill.parameter
                            .payload,
                          ...search,
                          date: da,
                          filter: filter == "null" ? "" : filter,
                          search: appoinmentId,
                        },
                      });
                    }}
                    paginationApiCall={(da, page, status, paymentMode) => {
                      if (paymentMode) {
                        callbackHandlerCounterSell.getBill.callback({
                          ...callbackHandlerCounterSell.getBill.parameter,
                          payload: {
                            ...callbackHandlerCounterSell.getBill.parameter
                              .payload,
                            date: da,
                            status: status,
                            filter: paymentMode,
                            page: page,
                            pageSize: 10,
                          },
                        });
                      } else {
                        callbackHandlerCounterSell.getBill.callback({
                          ...callbackHandlerCounterSell.getBill.parameter,
                          payload: {
                            ...callbackHandlerCounterSell.getBill.parameter
                              .payload,
                            date: da,
                            status: status,
                            page: page,
                            pageSize: 10,
                          },
                        });
                      }
                    }}
                    setBillCount={setBillCount}
                    billCount={billCount}
                    callback={(item) => {}}
                    filterData={(date, status, page) => {
                      callbackHandlerCounterSell.getBill.callback({
                        ...callbackHandlerCounterSell.getBill.parameter,
                        payload: {
                          ...callbackHandlerCounterSell.getBill.parameter
                            .payload,
                          date: date,
                          status: status,
                          page: page,
                          pageSize: 10,
                        },
                      });
                    }}
                  />
                )}
              </Grid>
            </>
          )}
        </Grid>
        <Drawer
          anchor={"right"}
          open={mobileTableDrawer}
          onClose={() => {
            dispatch(setMobileTableDrawer(false));
          }}
          onClick={() => setMobileTableDrawer(false)}
        >
          <TableWithBox
            data={bills}
            pagesCount={billCount?.totalBills}
            callgetAllEmp={(data) => {
              callbackHandlerCounterSell.getBill.callback({
                ...callbackHandlerCounterSell.getBill.parameter,
                payload: {
                  ...callbackHandlerCounterSell.getBill.parameter.payload,
                  ...data,
                },
              });
            }}
            filter={filter}
            setFilter={setFilter}
            billApiCall={(da) => {
              callbackHandlerCounterSell.getBill.callback({
                ...callbackHandlerCounterSell.getBill.parameter,
                payload: {
                  ...callbackHandlerCounterSell.getBill.parameter.payload,
                  date: da,
                },
              });
            }}
            paginationApiCall={(da, page, status, paymentMode) => {
              if (paymentMode) {
                callbackHandlerCounterSell.getBill.callback({
                  ...callbackHandlerCounterSell.getBill.parameter,
                  payload: {
                    ...callbackHandlerCounterSell.getBill.parameter.payload,
                    date: da,
                    status: status,
                    filter: paymentMode,
                    page: page,
                    pageSize: 10,
                  },
                });
              } else {
                callbackHandlerCounterSell.getBill.callback({
                  ...callbackHandlerCounterSell.getBill.parameter,
                  payload: {
                    ...callbackHandlerCounterSell.getBill.parameter.payload,
                    date: da,
                    status: status,
                    page: page,
                    pageSize: 10,
                  },
                });
              }
            }}
            billCount={billCount}
            callback={(item) => {}}
            filterData={(date, status, page) => {
              callbackHandlerCounterSell.getBill.callback({
                ...callbackHandlerCounterSell.getBill.parameter,
                payload: {
                  ...callbackHandlerCounterSell.getBill.parameter.payload,
                  date: date,
                  status: status,
                  page: page,
                  pageSize: 10,
                },
              });
            }}
          />
        </Drawer>
      </Box>
    </>
  );
}
